import { getSelectMessage } from '../../../../utils/formValidation/errorMessageFunctions';

export const validate = (newEntry) => {
    let newErrors = {};

    if (!newEntry.jobReadinessId) {
        newErrors.jobReadinessId = {
            error: true,
            message: getSelectMessage('job readiness')
        };
    }

    return newErrors;
};
